/**
 * In development, styles from @rocheglobal/roche-ui are injected via HMR
 * through gatsby-webpack-extensions.ts (using style-loader).
 * Only import the prebuilt CSS in production to avoid duplicate styles.
 */
if (process.env.NODE_ENV !== 'development') {
  require('@rocheglobal/roche-ui/roche-ui-styles');
}

import { BrowserDetectionService } from '@repo/roche-xx-shared';
import type { GatsbyBrowser } from 'gatsby';
import './src/services/storyblok-init';
import { ConsoleService } from './src/services/console';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  BrowserDetectionService.detectWebPSupport();

  /**
   * Limit the console verbosity in production.
   * IMPORTANT: Do not limit the console verbosity during development!
   */
  if (!process.env.GATSBY_WEBSITE_URL?.includes('localhost')) {
    ConsoleService.setVerbosity('no-whitelist');
  }
};
